<header>

  <!-- Main navigation bar -->
  <nav id="navigation-bar">
    <div class="dropdowns-container">
      <div class="dropdown">
        <button id="button-notifications" [attr.aria-label]="notificationsAriaLabel()" [appDropdownTriggerFor]="notificationsMenu" aria-haspopup="true" [attr.aria-expanded]="notificationsMenu.showDropdown()">
          <svg-icon alt="" src="assets/icons/common/bell.svg" svgClass="icon"></svg-icon>
          @if (hasNotifications()) {
            <svg-icon id="newNotifications" alt="" src="assets/icons/common/circle.svg" svgClass="new-notifications-indicator"></svg-icon>
          }
        </button>
        <app-dropdown id="notificationsMenu" #notificationsMenu [arrowBackgroundColour]="'arrow-grey'" [closeOnClick]="true">
          <app-notification-menu></app-notification-menu>
        </app-dropdown>
      </div>
      <div class="dropdown">
        <button id="button-account" aria-label="Account Menu Dropdown" [appDropdownTriggerFor]="accountMenu" aria-haspopup="true" [attr.aria-expanded]="accountMenu.showDropdown()">
          <svg-icon alt="" src="assets/icons/common/account.svg" svgClass="icon"></svg-icon>
        </button>
        <app-dropdown id="accountMenu" #accountMenu [arrowBackgroundColour]="'arrow-grey'" [closeOnClick]="true">
          <app-account-menu></app-account-menu>
        </app-dropdown>
      </div>
    </div>
    <button
      id="button-sidebar"
      aria-label="Sidebar Navigation"
      [attr.aria-expanded]="sidebar()!.isVisible()"
      (click)="sidebar()!.open()"
      [class.open]="!sidebar()!.isVisible()"
      [class.closed]="sidebar()!.isVisible()">
      <svg-icon alt="Sidebar Navigation" src="assets/icons/common/menu.svg"></svg-icon>
    </button>
  </nav>
</header>
